import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Alert,
  TextField,
  Stack,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { Wheel } from "react-custom-roulette";
import Duke from "../../images/DukeCone.webp";

export default function DiscountWheel({ close }) {
  const url = "https://dev.pmwevents.com";
  //   const url = "http://localhost:4100";
  const [customerEmail, setCustomerEmail] = useState("");
  const [discount, setDiscount] = useState("");
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    severity: "info",
  });
  const [emailError, setEmailError] = useState("");
  const [proceed, setProceed] = useState(false);

  // 8 segments: 4x 5%, 2x 10%, 1x 15%, 1x ticket (never lands on it)
  const wheelData = [
    { option: "5% OFF" }, // index 0
    { option: "10% OFF" }, // index 1
    { option: "5% OFF" }, // index 2
    { option: "15% OFF" }, // index 3
    { option: "5% OFF" }, // index 4
    { option: "10% OFF" }, // index 5
    { option: "5% OFF" }, // index 6
    { option: "Free Inner Circle 🎟️" }, // index 7
  ];

  // Weights mapped to indexes of the `wheelData` array (excluding the Ticket at index 7)
  const weightedSpin = () => {
    const r = Math.random();

    if (r < 0.225) return 0; // 22.5% → 5% OFF
    else if (r < 0.45) return 2; // 22.5% → 5% OFF
    else if (r < 0.675) return 4; // 22.5% → 5% OFF
    else if (r < 0.9) return 6; // 22.5% → 5% OFF
    else if (r < 0.94) return 1; // 4%    → 10% OFF
    else if (r < 0.98) return 5; // 4%    → 10% OFF
    else return 3; // 2%    → 15% OFF
    // index 7 (🎟️) is never chosen
  };

  const handleWheelSpin = () => {
    let wheelCheck = localStorage.getItem("wheel");
    if (wheelCheck) {
      setAlert({
        show: true,
        message: "You've already spun the wheel!",
        severity: "warning",
      });
      setTimeout(() => {
        setAlert({ show: false, message: "", severity: "info" });
      }, 5000);
      return;
    }

    const index = weightedSpin();
    setPrizeNumber(index);
    setMustSpin(true);
    localStorage.setItem("wheel", "true");
  };

  const handleSpinStop = () => {
    setMustSpin(false);
    setDiscount(wheelData[prizeNumber].option);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async () => {
    if (!validateEmail(customerEmail)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    setEmailError("");
    setLoading(true);

    try {
      await axios.post(`${url}/sbc/sbc-discount`, {
        customerEmail: customerEmail.toLowerCase(),
        discount,
      });
      setAlert({
        show: true,
        message: "Discount Code Emailed Successfully!",
        severity: "success",
      });
      setTimeout(() => {
        setAlert({ show: false, message: "", severity: "info" });
        close(false);
      }, 3000);
    } catch (err) {
      console.error(err);
      setAlert({
        show: true,
        message: err.response.data.message,
        severity: "error",
      });
      setTimeout(() => {
        setAlert({ show: false, message: "", severity: "info" });
        close(false);
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {proceed ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#93e3d3",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            overflowX: "hidden",
            "@media(min-width: 780px)": {
              maxHeight: "90%",
              overflowY: "scroll",
            },
          }}
        >
          <Stack spacing={2}>
            {alert.show && (
              <Alert severity={alert.severity}>{alert.message}</Alert>
            )}

            <Wheel
              mustStartSpinning={mustSpin}
              prizeNumber={prizeNumber}
              data={wheelData}
              backgroundColors={[
                "#1b505a",
                "#226879",
                "#0e2f35",
                "#04181b",
                "#1b505a",
                "#226879",
                "#0e2f35",
                "#D4AF37",
              ]}
              textColors={[
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#FFFFFF",
                "#04181b",
              ]}
              fontSize={13}
              onStopSpinning={handleSpinStop}
            />

            {!discount ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#0e2f35 !important",
                  "&:hover": {
                    backgroundColor: "#143f48 !important",
                    color: "#fff",
                  },
                  "&:disabled": {
                    color: "#fff",
                    backgroundColor: "grey",
                  },
                }}
                onClick={handleWheelSpin}
                disabled={mustSpin}
              >
                {mustSpin ? "Spinning…" : "Spin"}
              </Button>
            ) : (
              <>
                <Typography align="center">
                  You won: <strong>{discount}</strong>
                </Typography>
                <TextField
                  label="Enter Your Email Address"
                  type="email"
                  fullWidth
                  value={customerEmail}
                  onChange={(e) => setCustomerEmail(e.target.value)}
                  error={!!emailError}
                  helperText={emailError}
                />
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loading || !customerEmail}
                  sx={{
                    backgroundColor: "#0e2f35 !important",
                    "&:hover": {
                      backgroundColor: "#143f48 !important",
                    },
                  }}
                >
                  {loading ? <CircularProgress size={24} /> : "Submit"}
                </Button>
              </>
            )}

            <Button
              disabled={(loading, mustSpin)}
              onClick={() => close(false)}
              variant="contained"
              sx={{ backgroundColor: "#e8160c" }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      ) : (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "min(90vw, calc(90vh * 0.75))", // ensures it fits within both width and height
            aspectRatio: "3 / 4", // maintains shape
            boxShadow: 24,
            overflow: "hidden",
            backgroundImage: `url(${Duke})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            bgcolor: "#93e3d3",
            cursor: "pointer",
          }}
          onClick={() => setProceed(true)}
        />
      )}
    </>
  );
}
